import { createAction, props } from '@ngrx/store';

interface ModalShow {
  title: string;
  text: string;
}
export const modalErrorShow = createAction(
  '[Modal-error] Show',
  props<ModalShow>(),
);
